const getVariantById = (variants, id) => {
  return variants.find(variant => variant.id === id);
};

export default getVariantById;
